import {
  initialState,
  Actions,
  State,
  EDIT_CONTACT,
  EDIT_CONTACT_SUCCESS,
  EDIT_CONTACT_ERROR,
  RESET_EDIT_CONTACT,
} from '../../types/contact/edit'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_CONTACT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case EDIT_CONTACT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case EDIT_CONTACT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      }
    case RESET_EDIT_CONTACT:
      return initialState
    default:
      return state
  }
}

export default reducers
